/*
 * Put-discounts.ts
 * Description: Includes the declaration
 * of the function for updating a discount
 */

// Importing Axios for HTTP requests
import Axios from 'axios';
// Importing required global variables
import {APIURL} from '@/ts/variables';
// Importing an interface
import {Discount} from '@/ts/discounts/validate-discount';

/**
 * Updating a discount
 *
 * @return {Object} Promise - when the request has been fulfilled
 * @param {Discount} data - discount data
 * @param {String} slug - slug of the restaurant
 * @param {Number} id - id of the discount
 */
export function putDiscount(data: Discount, slug: string, id: number) {
    const jwt = localStorage.getItem('jwt');
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        Axios({
            url:  APIURL + 'restaurants/' + slug + '/discounts/' + id,
            method: 'put',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data,
        }).then(() => {
            resolve();
        }).catch(() => {
            reject();
        });
    });
}
